import VerifiedBadge from '../../common/components/VerifiedBadge';
export function findVnodeByClass(node, className) {
  if (!node || typeof node !== 'object') return null;
  if (Array.isArray(node)) {
    for (const child of node) {
      const found = findVnodeByClass(child, className);
      if (found) return found;
    }
    return null;
  }
  const v = node;
  const cls = v.attrs && v.attrs.className;
  if (typeof cls === 'string' && cls.split(/\s+/).indexOf(className) !== -1) {
    return v;
  }
  if (v.children) return findVnodeByClass(v.children, className);
  return null;
}
export function makeVerifiedVnode(user, className) {
  if (!user || !user.isVerified || !user.isVerified()) return null;
  return m(VerifiedBadge, {
    user,
    className
  });
}
flarum.reg.add('ramon-verified', 'forum/utils/vnodeTree', { findVnodeByClass: findVnodeByClass,makeVerifiedVnode: makeVerifiedVnode, });